import { StyledCard } from '@app/components/StyledCard';
import { Station } from '@mi-front/core';
import { SxProps, Theme, styled } from '@mui/material';

const StyledLogo = styled('img')({
  height: '2rem',
  width: '2rem',
  borderRadius: '50%',
  border: '1px solid #ccc',
});

interface Props {
  station: Station;
  children: React.ReactNode;
  actions?: React.ReactNode;
  sx?: SxProps<Theme>;
}

export function StationCard({ station, children, actions, sx }: Props) {
  return (
    <StyledCard
      avatar={
        station.logoUrl ? (
          <StyledLogo src={station.logoUrl} alt={`${station.name} logo`} />
        ) : undefined
      }
      title={station.name}
      actions={actions}
      sx={sx}
    >
      {children}
    </StyledCard>
  );
}
